module.exports = __webpack_public_path__ + "img/laws-2.df10c7d4.png";